"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = React.createElement;
function SvgComponent(props) {
  return __jsx("svg", (0, _extends2.default)({
    width: 20,
    height: 20,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), __jsx("g", {
    strokeWidth: 1.3,
    transform: "translate(1 1)",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, __jsx("path", {
    d: "M9.375 15.193v2.932c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-2.932M19.375 14.568l-5.417-4.872a1.25 1.25 0 00-1.671 0L6.87 14.568M18.125 13.443V10"
  }), __jsx("circle", {
    cx: 6.875,
    cy: 6.875,
    r: 3.125
  }), __jsx("path", {
    d: "M6.875 19.375a.624.624 0 01-.52-.28C4.852 16.833.624 9.715.624 6.875a6.25 6.25 0 1112.5 0"
  })));
}
var _default = exports.default = SvgComponent;